const FontAwesomeIcon = ({ icon }) => {
  return <i className={icon}></i>;
};

export default FontAwesomeIcon;
